import { css } from 'aphrodite';

import stylesCommons from '../StylesCommons';

interface Permission {
    requiredPermission?: string;
}
export default function MissingPermissionsPage(requiredPermission: Permission) {
    return (
        <div className={css(stylesCommons.formContent)}>
            <h1>403</h1>
            <h2>You don&apos;t have permission to see this page!</h2>
            <h3>Missing permission: {requiredPermission.requiredPermission}</h3>
        </div>
    );
}
